import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter, useInRouterContext } from 'react-router-dom'
import App from './App.jsx'
import './index.css'

function SafeBrowserRouter({ children }) {
  let inRouter = false
  try {
    inRouter = useInRouterContext()
  } catch (e) {
    // Fallback hvis noget fejler
  }

  if (inRouter) {
    return <>{children}</>
  }
  return <BrowserRouter>{children}</BrowserRouter>
}

createRoot(document.getElementById('root')).render(
  <SafeBrowserRouter>
    <App />
  </SafeBrowserRouter>
)
